/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationsService {

    /**
     * A mixin class that integrates security context filtering into querysets.
     *
     * This class is designed to be used with Django REST framework's GenericAPIView
     * to enhance queryset filtering based on a security context. The security field
     * specified in this mixin is used in combination with the security context ID
     * from the request to filter querysets appropriately. This ensures that only
     * objects matching the security context are retrieved.
     *
     * Attributes:
     * healthcare_entity_security_field (str): The name of the model field used for filtering based
     * on the id of the healthcare entity.
     * provider_security_field (str): The name of the model field used for filtering based
     * on the id of the provider.
     * @returns any No response body
     * @throws ApiError
     */
    public static notificationsBadgesMenuRetrieve({
        scope,
    }: {
        /**
         * Explicit scopes to calculate badge for
         */
        scope?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notifications/badges/menu/',
            query: {
                'scope': scope,
            },
        });
    }

    /**
     * A mixin class that integrates security context filtering into querysets.
     *
     * This class is designed to be used with Django REST framework's GenericAPIView
     * to enhance queryset filtering based on a security context. The security field
     * specified in this mixin is used in combination with the security context ID
     * from the request to filter querysets appropriately. This ensures that only
     * objects matching the security context are retrieved.
     *
     * Attributes:
     * healthcare_entity_security_field (str): The name of the model field used for filtering based
     * on the id of the healthcare entity.
     * provider_security_field (str): The name of the model field used for filtering based
     * on the id of the provider.
     * @returns any No response body
     * @throws ApiError
     */
    public static notificationsBadgesScopeRetrieve({
        scope,
    }: {
        /**
         * Scope to return queue counts for
         */
        scope: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notifications/badges/scope/',
            query: {
                'scope': scope,
            },
        });
    }

}
